function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 0 11.73 C 0 10.272 1.184 9.091 2.64 9.091 L 46.045 9.091 C 47.502 9.091 48.684 10.273 48.684 11.73 C 48.684 13.188 47.502 14.37 46.045 14.37 L 2.64 14.37 C 1.184 14.371 0 13.188 0 11.73 Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M 65.706 3.136 L 52.436 3.136 C 51.332 3.136 50.434 4.031 50.434 5.138 C 50.434 6.244 51.33 7.14 52.436 7.14 L 65.707 7.14 C 66.811 7.14 67.709 6.244 67.709 5.138 C 67.708 4.031 66.811 3.136 65.706 3.136 Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M 60.202 10.088 C 59.902 9.788 59.495 9.619 59.07 9.619 C 58.646 9.619 58.238 9.787 57.937 10.088 L 54.544 13.482 C 53.919 14.107 53.919 15.121 54.544 15.745 C 55.169 16.37 56.183 16.37 56.808 15.745 L 57.47 15.082 L 57.47 20.117 C 57.47 21.001 58.187 21.717 59.07 21.717 C 59.954 21.717 60.671 21.001 60.671 20.117 L 60.671 15.082 L 61.333 15.745 C 61.958 16.37 62.973 16.37 63.598 15.745 C 63.91 15.433 64.067 15.023 64.067 14.613 C 64.067 14.204 63.91 13.795 63.598 13.482 L 60.202 10.088 Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M 31.401 50.337 L 3.245 50.337 C 1.789 50.337 0.605 51.519 0.605 52.976 C 0.605 54.435 1.789 55.617 3.245 55.617 L 31.401 55.617 C 32.858 55.617 34.041 54.435 34.041 52.976 C 34.041 51.519 32.858 50.337 31.401 50.337 Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M 46.648 40.433 L 3.245 40.433 C 1.789 40.433 0.605 41.615 0.605 43.072 C 0.605 44.531 1.789 45.713 3.245 45.713 L 46.648 45.713 C 48.105 45.713 49.288 44.531 49.288 43.072 C 49.288 41.615 48.105 40.433 46.648 40.433 Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M 2.64 24.273 L 30.797 24.273 C 32.253 24.273 33.435 23.092 33.435 21.634 C 33.435 20.176 32.253 18.995 30.797 18.995 L 2.64 18.995 C 1.184 18.995 0 20.176 0 21.634 C 0 23.092 1.184 24.273 2.64 24.273 Z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

function SvgPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "67.708px",
    height: "67.708px",
    viewBox: "0 0 67.708 67.708",
    style: {
      enableBackground: "new 0 0 67.708 67.708"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.29b1ca7c.svg";
export { ForwardRef as ReactComponent };